import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import About from "./pages/About";
import Admin from "./pages/Admin";

function App() {
    return (
        <div className="App min-h-screen bg-ac-bg text-white font-sans">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#121212",
                        border: "1px solid rgba(157,76,221,0.35)",
                        color: "#ffffff",
                    },
                }}
            />
        </div>
    );
}

export default App;
